'use strict';

/**
 * Drop-in replacement for sockjs-client/lib/utils/event.js, swapped in via
 * NormalModuleReplacementPlugin (next.config.js).
 *
 * WHY (2026-08-31, owner console report): the original module registers a global
 * 'unload' listener at import time. Chrome now denies 'unload' via permissions
 * policy — every page logged "[Violation] Permissions policy violation: unload is
 * not allowed" at bootstrap, and the cleanup never actually ran. This shim keeps
 * the exact API but binds 'pagehide' instead:
 *  - event.persisted === false → real teardown → run sockjs's unload callbacks
 *    (close transports), same as before.
 *  - event.persisted === true → page entering bfcache → do NOTHING: killing the
 *    sockets would strand a restored page; the browser freezes them and our
 *    websocket.service reconnect path covers restores. (The old 'unload' listener
 *    also made pages bfcache-INELIGIBLE — this shim removes that penalty.)
 */

var random = require('sockjs-client/lib/utils/random');

var onUnload = {};
var afterUnload = false;
var isChromePackagedApp =
  typeof global.chrome !== 'undefined' && global.chrome && global.chrome.app && global.chrome.app.runtime;

module.exports = {
  attachEvent: function(event, listener) {
    if (typeof global.addEventListener !== 'undefined') {
      global.addEventListener(event, listener, false);
    } else if (global.document && global.attachEvent) {
      global.document.attachEvent('on' + event, listener);
      global.attachEvent('on' + event, listener);
    }
  },

  detachEvent: function(event, listener) {
    if (typeof global.addEventListener !== 'undefined') {
      global.removeEventListener(event, listener, false);
    } else if (global.document && global.detachEvent) {
      global.document.detachEvent('on' + event, listener);
      global.detachEvent('on' + event, listener);
    }
  },

  unloadAdd: function(listener) {
    if (isChromePackagedApp) {
      return null;
    }
    var ref = random.string(8);
    onUnload[ref] = listener;
    if (afterUnload) {
      setTimeout(this.triggerUnloadCallbacks, 0);
    }
    return ref;
  },

  unloadDel: function(ref) {
    if (ref in onUnload) {
      delete onUnload[ref];
    }
  },

  triggerUnloadCallbacks: function() {
    for (var ref in onUnload) {
      onUnload[ref]();
      delete onUnload[ref];
    }
  }
};

var pagehideTriggered = function(e) {
  if (afterUnload) {
    return;
  }
  if (e && e.persisted) {
    // bfcache entry, not a teardown — keep transports alive.
    return;
  }
  afterUnload = true;
  module.exports.triggerUnloadCallbacks();
};

if (!isChromePackagedApp && typeof global.addEventListener !== 'undefined') {
  global.addEventListener('pagehide', pagehideTriggered, false);
}
